<template>
  <div class="popover-container" @mouseenter="showPopover" @mouseleave="startHideTimer">
    <!-- 触发元素 -->
    <div class="trigger" ref="trigger">
      <slot name="trigger"></slot>
    </div>
    
    <!-- 弹出内容 -->
    <div 
      class="popover-content" 
      v-show="isVisible" 
      :style="popoverStyle" 
      ref="content"
      @mouseenter="clearHideTimer"
      @mouseleave="startHideTimer"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Popover',
  props: {
    // 弹出位置
    position: {
      type: String,
      default: 'top',
      validator: (value) => ['top', 'bottom', 'left', 'right'].includes(value)
    },
    // 偏移距离
    offset: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      isVisible: false,
      popoverStyle: {
        top: '0',
        left: '0'
      },
      hideTimer: null
    };
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.updatePosition, true);
    // 将弹出内容移到 body 下
    document.body.appendChild(this.$refs.content);
  },
  beforeDestroy() {
    // 清理事件监听和 DOM
    window.removeEventListener('scroll', this.updatePosition, true);
    if (this.$refs.content && this.$refs.content.parentNode) {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    }
  },
  methods: {
    showPopover() {
      this.clearHideTimer();
      this.isVisible = true;
      this.$nextTick(() => {
        this.updatePosition();
      });
    },
    startHideTimer() {
      this.clearHideTimer();
      this.hideTimer = setTimeout(() => {
        this.hidePopover();
      }, 200);
    },
    clearHideTimer() {
      if (this.hideTimer) {
        clearTimeout(this.hideTimer);
        this.hideTimer = null;
      }
    },
    hidePopover() {
      this.isVisible = false;
    },
    updatePosition() {
      const triggerEl = this.$refs.trigger;
      const popoverEl = this.$refs.content;
      
      if (!triggerEl || !popoverEl) return;
      
      const triggerRect = triggerEl.getBoundingClientRect();
      const popoverRect = popoverEl.getBoundingClientRect();
      
      // 计算相对于视口的位置
      let top = triggerRect.top;
      let left = triggerRect.left;
      
      switch (this.position) {
        case 'top':
          top = triggerRect.top - popoverRect.height - this.offset;
          left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2;
          break;
        case 'bottom':
          top = triggerRect.bottom + this.offset;
          left = triggerRect.left + (triggerRect.width - popoverRect.width) / 2;
          break;
        case 'left':
          top = triggerRect.top + (triggerRect.height - popoverRect.height) / 2;
          left = triggerRect.left - popoverRect.width - this.offset;
          break;
        case 'right':
          top = triggerRect.top + (triggerRect.height - popoverRect.height) / 2;
          left = triggerRect.right + this.offset;
          break;
      }
      
      // 防止弹出层超出视口
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      
      // 确保不超出右边界
      if (left + popoverRect.width > viewportWidth) {
        left = viewportWidth - popoverRect.width - 5;
      }
      // 确保不超出左边界
      if (left < 5) {
        left = 5;
      }
      // 确保不超出上边界
      if (top < 5) {
        top = 5;
      }
      // 确保不超出下边界
      if (top + popoverRect.height > viewportHeight) {
        top = viewportHeight - popoverRect.height - 5;
      }
      
      this.popoverStyle = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }
};
</script>

<style lang="less" scoped>
.popover-container {
  position: relative;
}

.popover-content {
  position: fixed;
  z-index: 9999;
  background: white;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  transition: opacity 0.3s, transform 0.3s;
  min-width: 100px;
}

.popover-content[v-show="false"] {
  opacity: 0;
  transform: scale(0.9);
}

.popover-content[v-show="true"] {
  opacity: 1;
  transform: scale(1);
}
</style>
